import moment from 'moment';

class MonthSelectorController {
  constructor(EventEmitter) {
    'ngInject';
    this.eventEmitter = EventEmitter;
  }

  $onInit() {
    moment.locale('es');
    this.moment = moment();
    this._initLiterals();
    this.onChange(this.eventEmitter(this._toDate()));
  }

  prev() {
    this.moment.subtract(1, 'month');
    this._initLiterals();
    this.onChange(this.eventEmitter(this._toDate()));
  }

  next() {
    this.moment.add(1, 'month');
    this._initLiterals();
    this.onChange(this.eventEmitter(this._toDate()));
  }

  _initLiterals() {
    this.monthLiteral = this.moment.format('MMMM');
    this.yearLiteral = this.moment.format('YYYY');
  }

  _toDate() {
    return this.moment.toDate();
  }
}

export default MonthSelectorController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/monthSelector/monthSelector.controller.js